import React from "react";

const DisputeLog = ({ disputeDetail }) => {
  return (
    <>
      {Object.keys(disputeDetail).length !== 0 && (
        <section id="dispute-log">
          <div className="container theme-section">
            <h1 className="section-tittle text-center">Dispute Log</h1>

            <div className="dispute-log-area" total-item="4">
              {disputeDetail.reason_of_dispute != null && (
                <div className="dispute-log-card">
                  <span className="dispute-time"></span>

                  <p>
                    <b>Reason Of Dispute</b>
                    <br />
                    <span>Reason:</span>
                    {disputeDetail.reason_of_dispute}
                  </p>
                </div>
              )}

              {disputeDetail.reason_of_other_party_disagree != null && (
                <div className="dispute-log-card">
                  <span className="dispute-time"></span>

                  <p>
                    <b>Other Party Response</b>
                    <br />
                    <span>Reason:</span>
                    {disputeDetail.reason_of_other_party_disagree}
                  </p>
                </div>
              )}

              {disputeDetail.reason_of_withdraw != null && (
                <div className="dispute-log-card">
                  <span className="dispute-time"> </span>

                  <p>
                    <b>Reason of Withdraw</b>
                    <br />
                    <span>Reason:</span>
                    {disputeDetail.reason_of_withdraw}
                  </p>
                </div>
              )}

              {disputeDetail.reason_of_admin != null && (
                <div className="dispute-log-card">
                  <span className="dispute-time"></span>

                  <p>
                    <b>Admin Response</b>
                    <br />
                    <span>Reason:</span>
                    {disputeDetail.reason_of_admin}
                  </p>
                </div>
              )}
            </div>
          </div>
        </section>
      )}
    </>
  );
};

export default DisputeLog;
